export class SharedTranslationConfig {
    public labels: any;
}
